import React from "react";
import { useParams } from "react-router-dom";
import CaseListPage from "./CaseListPage";
import { totalCasesConfig } from "./caseListConfig";

/** The route still honours a :type param, as it did before. */
const IndexUserTotalCases = () => {
  const { type } = useParams();
  return <CaseListPage config={ { ...totalCasesConfig, type: type || totalCasesConfig.type } } />;
};

export default IndexUserTotalCases;
